module.exports = __webpack_public_path__ + "static/media/shutdown.66126156.svg";